export default "__VITE_ASSET__D1Xu1Y4N__"